<template>
	<div class="assemblyBgColor introduce" :class="sourceStr == 'isShare' ? 'sourceShare' : '' ">
		<div class="tit">游戏介绍</div>
		<div class="introduceMain">
			<div class="item videowrap" v-for="item in gameInfObj.videos" :key="item">
				<video
					id="myVideo"
					class="video-js vjs-big-play-centered"
					poster='~assets/dream/img/cover.png'
					controls="controls"
				>
					<source
						width='100%'
						height='100%'
						:src="item"
						type="video/mp4"
					>
				</video>
			</div>
			<div class="item imgItem" v-for="item in gameInfObj.imageUrls" :key="item">
				<img :src="item" alt="" />
			</div>
		</div>
		<div class="introduceTxt">{{gameInfObj.newDescription ? gameInfObj.newDescription : gameInfObj.description}}<span v-if="gameInfObj.newDescription" @click="showMore">更多</span></div>
	</div>
</template>

<script>
import Vue from 'vue';
import config from "@/../config";
import active from '@/utils/axios/index'
import qs from 'qs'
import { Toast } from 'vant';
Vue.use(Toast);
export default {
	name: 'introduce',
	props: ['sourceStr', 'gameId'],
	data(){
		return {
			gameInfObj: {}, //游戏介绍信息
		}
	},
	mounted() {
		this.getGamesByIds()
	},
	methods: {
		//根据gameId获取游戏信息
		getGamesByIds() {
			active.getGamesByIds(config.API_HOST + "/apiserv/api/repository/game/getGamesByIds",qs.stringify({
				ids: this.gameId
			})).then((res) => {
				if (res.return_code != 200) {
					this.$toast(res.return_msg);
					return;
				}
				let newData = JSON.parse(JSON.stringify(res.data[0].detail));
				if(newData.description.length > 68){
					newData.newDescription = newData.description.substring(0, 68) + '...';
				}
				this.gameInfObj = newData;
				this.$emit('setGameInf', res.data[0].detail);
			}).catch((error) => {
				this.$toast('网络不稳定，请稍后');
			});
		},
		//显示更多
		showMore() {
			this.gameInfObj.newDescription = '';
		}
	}
}
</script>

<style>
	.introduce{
		margin-top: 0.08rem;
		padding: 0.2rem 0 0.2rem 0.14rem;
	}
	.introduce .tit{
		color: rgba(255,255,255,0.9);
		font-size: 0.18rem;
	}
	.introduceMain{
		overflow-y: hidden;
		overflow-x: scroll;
		white-space: nowrap;
		font-size: 0;
		-webkit-overflow-scrolling: touch;
		margin-top: 0.13rem;
	}
	.introduceMain::-webkit-scrollbar {display:none}
	.introduceMain .item{
		width: 1.44rem;
		height: 2.4rem;
		margin-right: 0.08rem;
		border-radius: 0.08rem;
		overflow: hidden;
	}
	.introduceMain .item:last-child{
		margin-right: 0;
	}
	.videowrap{
		display: inline-block;
		vertical-align: top;
	}
	.videowrap .video-js{
		width: 100%;
		height: 100%;
	}
	.imgItem{
		display: inline-block;
		vertical-align: top;
	}
	.imgItem img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.introduceTxt{
		overflow: hidden;
		/* display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3; */
		width: 100%;
		font-size: 0.14rem;
		padding-right: 0.14rem;
		color: rgba(255,255,255,0.60);
		position: relative;
		margin-top: 0.15rem;
	}
	.introduceTxt span{
		position: absolute;
		right: 0.18rem;
		bottom: 0;
		color: #FF9500;
		font-size: 0.14rem;
	}
	.sourceShare{
		margin-top: 0;
		padding-top: 0.08rem;
	}
	.sourceShare .tit{
		color: #333333;
		font-weight: bold;
	}
	.sourceShare .introduceTxt{
		color: #666666;
	}
</style>
